import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';
import * as ProfileActions from '@profile/profile.actions';

import { TwoFAScreen } from '@shared/models/Profile';

@Component({
  selector: 'app-profile-verify',
  styleUrls: ['./profile-verify.component.scss'],
  templateUrl: './profile-verify.component.html',
  standalone: false
})
export class ProfileVerifyComponent implements OnChanges, AfterViewInit {
  @ViewChild('verifyCodeInput') inputElement: ElementRef;
  @Input() enabled2FA: boolean;
  @Input() phoneNumber: string;
  @Input() loading: boolean;
  @Input() token: string;
  @Input() location: 'personalDetails' | '2FA' = '2FA';
  @Output() resendSMSCode = new EventEmitter<boolean>();
  @Output() validateCode = new EventEmitter<string>();

  verifyForm: FormGroup;
  visible = false;

  constructor(
    private formBuilder: FormBuilder,
    private store: Store
  ) {
    this.verifyForm = this.formBuilder.group({
      code: ['', Validators.required]
    });

    this.verifyForm.get('code').valueChanges.subscribe((code: string) => {
      if (code && code.length === 6) {
        this.validateCode.emit(code);
      }
    });
  }

  goBack(): void {
    this.store.dispatch(ProfileActions.update2FACurrentScreen({ screen: this.enabled2FA ? 'main' : 'phone' }));
  }

  changeScreen(screen: TwoFAScreen): void {
    this.store.dispatch(ProfileActions.update2FACurrentScreen({ screen }));
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.inputElement && this.inputElement.nativeElement) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.inputElement.nativeElement.focus();
      }
    }, 1200);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.loading && changes.loading.currentValue === false) {
      this.verifyForm.get('code').setValue('');
      this.verifyForm.updateValueAndValidity();
    }
  }

  resendCode(): void {
    this.resendSMSCode.emit(true);
  }

  send(): void {
    if (this.verifyForm.invalid) {
      this.verifyForm.get('password').markAllAsTouched();
    }
  }
}
